import React from 'react';

import './FieldError.css';

// Says what is wrong with a field. The red border alone is a colour-only cue,
// so an invalid field also gets these words and an icon.
const FieldError = ({ id, show, children }) =>
  show ? (
    <span id={id} className="field-error">
      <span className="fa fa-exclamation-circle" aria-hidden="true" />
      {children}
    </span>
  ) : null;

export default FieldError;



// WEBPACK FOOTER //
// ./src/components/UI/FieldError/index.js